import React from "react";
import { ReactComponent as NavIcon } from "@/assets/sidebar/nav.svg?react";
import { SideBarToggleButton } from "./styles";

interface ToggleButtonProps {
  isCollapsed: boolean;
  onClick: () => void;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  isCollapsed,
  onClick,
}) => (
  <SideBarToggleButton $isCollapsed={isCollapsed}>
    <NavIcon onClick={onClick} style={{ width: "35px", height: "39px" }} />
  </SideBarToggleButton>
);
